import { useTranslate } from '@tolgee/react';
import { WidgetWrapper } from '@agentselly/ui';

export function PartnerWelcomeWidget(props: Props) {
  const { t } = useTranslate();

  return (
    <WidgetWrapper>
      <p>
        {t('partner_welcome', {
          name: props.name,
          address: props.address,
        })}
      </p>
    </WidgetWrapper>
  );
}

interface Props {
  readonly name: string;
  readonly address: string;
}
